/**
 * 颜色常量统一管理
 *
 * 使用方式：
 * - 在 sx prop 中直接使用：sx={{ color: COLORS.primary.main }}
 * - 在组件中使用 useTheme()：const theme = useTheme(); theme.palette.primary.main
 *
 * 注意：优先使用 theme.palette，仅在需要非主题色时使用此文件
 */

/** 主题色映射（与 palette.ts 保持一致） */
export const COLORS = {
  primary: {
    main: '#1E88E5',
    dark: '#1565C0',
    light: '#E3F2FD',
    hover: '#1976D2',
  },
  secondary: {
    main: '#43A047',
    dark: '#2E7D32',
    light: '#E8F5E9',
  },
  error: {
    main: '#E53935',
    light: '#FFEBEE',
    dark: '#C62828',
  },
  warning: {
    main: '#FB8C00',
    light: '#FFF3E0',
    dark: '#E65100',
  },
  success: {
    main: '#43A047',
    light: '#E8F5E9',
    dark: '#2E7D32',
  },
  info: {
    main: '#00d4aa',
    light: '#E0F7F4',
    dark: '#00838F',
  },
  grey: {
    50: '#F8F9FB',
    100: '#F0F2F5',
    200: '#E8EAED',
    300: '#DADCE0',
    400: '#BDC1C6',
    500: '#9E9E9E',
    600: '#80868B',
    700: '#616161',
    800: '#3C4043',
    900: '#212121',
  },
  background: {
    default: '#F5F7FA',
    paper: '#FFFFFF',
    dark: '#0a1628',
  },
  text: {
    primary: '#212121',
    secondary: '#616161',
    disabled: '#9E9E9E',
  },
  divider: '#E8EAED',
} as const;

/** 状态颜色映射（用于 StatusChip 等组件） */
export const STATUS_COLORS = {
  success: COLORS.success.main,
  warning: COLORS.warning.main,
  error: COLORS.error.main,
  info: COLORS.info.main,
  default: COLORS.grey[500],
} as const;

/** 图表颜色（用于 Recharts 等） */
export const CHART_COLORS = {
  blue: COLORS.primary.main,
  green: COLORS.success.main,
  orange: COLORS.warning.main,
  red: COLORS.error.main,
  teal: COLORS.info.main,
  purple: '#7B1FA2',
  pink: '#E91E63',
  indigo: '#3F51B5',
} as const;
